module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARRJREFUOBGtVTEOgzAMJEh8ou/oni+UgQehbuxVX8Deh3RtJaTOHbrSrQO9AwcFE4QEsXQ1OePDJiY1ScC6rstAnwRH+IPc9oa/AzfCGPMTftlBLAdewJrxnnxRCcEUqNZUAnHmpDPhjWJOv5oIgmWbe21oHyoZoN/ZB9wF+ALayJ2BpwpQI0vwU6gAl1e2AG8BX5TXVmIlrrUVTKo1i7WfaGUd4nRqTcFGs7LWAq4yizhjIWso2IYiwo2iC69Ap7bz+WHmHsMjorccfVNCY1Oya1RvAX8DxncKnrOorR+b0GBzaJngi7lkcpzBhyPED4MtlcT79NyG4ilbThpX5PRwkCrjHl9epbsOWOOEfI8+Nv8F/AEt2WcqMihOqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./component/dialog/images/close.png
// module id = 193
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27